export const CURRENT_NODE_OPTION_VALUE = '__currentNode__' as const
